/**
 * WebSocket reconnection utilities.
 * Provides exponential backoff with jitter for reconnection delays
 * and shared configuration constants.
 */

export const WS_MAX_RECONNECT_ATTEMPTS = 15
export const WS_BASE_RECONNECT_DELAY_MS = 1000
export const WS_MAX_RECONNECT_DELAY_MS = 30_000
export const WS_AUTO_RECONNECT_INTERVAL_MS = 30_000

/**
 * Calculates reconnection delay using exponential backoff with jitter.
 * Formula: min(base * 2^(attempt-1) + random_jitter, maxDelay)
 *
 * Example delays (without jitter): 1s, 2s, 4s, 8s, 16s, 30s, 30s...
 */
export const calculateReconnectDelay = (
  attempt: number,
  baseDelay: number = WS_BASE_RECONNECT_DELAY_MS,
  maxDelay: number = WS_MAX_RECONNECT_DELAY_MS
): number => {
  const exponentialDelay = baseDelay * 2 ** (attempt - 1)
  const jitter = Math.random() * baseDelay
  return Math.min(exponentialDelay + jitter, maxDelay)
}
